import React, { useEffect, useRef, useState, useCallback } from "react";
import Alert from "react-bootstrap/Alert";
import { FaPrint, FaRedo } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { useReactToPrint } from "react-to-print";
import Logo from "../../assets/img/AaysLogo.png";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Form, Row, Col } from "react-bootstrap";
import { DialogActions, DialogContentText } from "@mui/material";
import { apiService } from "../../services/apiClient";
import { apiUrl } from "../../services/apiUrl";
import Select from "react-select";
import preloadimg from "../../assets/img/preloader1.gif";
import Exportuserlist from "../layout/Exportuserlist";
import AppButton from "../layout/AppButton";
import RankedTable from "../layout/RankedTable";
import { useUserAdmin } from "../../hooks/useUserAdmin";
import { useRoleAdmin } from "../../hooks/useRoleAdmin";
import { useToolRoleAdmin } from "../../hooks/useToolRoleAdmin";
import uiConfig from "../../config/uiConfig";

const UserManagement = ({ passtoken }) => {
  const [isLoading, setIsloading] = useState(true);
  const [issuccess, setsuccess] = useState(false);
  const [iserror, seterror] = useState(false);
  const [query, setQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const currentPagelimit = 20;
  const [userType, setUsertype] = useState("");
  const [userGroup, setUserGroup] = useState("");
  const [Deleteinguser, setDeleteinguser] = useState(false);
  const [userinfo, setuserinfo] = useState([]);

  // Update form state
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [UpdateisLoading, setUpdateisLoading] = useState(false);
  const [UpdateuserType, setUpdateuserType] = useState("");
  const [EmailAdress, setEmail] = useState("");
  const [selectedOptionsPersona, setselectedOptionsPersona] = useState([]);
  const [selectedPersona1, setselectedPersona1] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsDataRl, setselectedOptionsDataRl] = useState([]);
  const [selectedOptionsToolRoles, setselectedOptionsToolRoles] = useState([]);
  const [selectedToolRoleIds, setSelectedToolRoleIds] = useState([]);
  const [ResetselectedOptionsToolRoles, setResetselectedOptionsToolRoles] =
    useState([]);
  const [ResetUpdateuserType, setResetUpdateuserType] = useState("");
  const [ResetselectedOptionsPersona, setResetselectedOptionsPersona] =
    useState([]);

  // Delete popup
  const [isDelete, setisDelete] = useState(false);
  const [deleteUserEmail, setdeleteUserEmail] = useState("");
  const [Deleteissuccess, setDeleteissuccess] = useState(false);

  const [userGroupMap, setUserGroupMap] = useState({});
  const [userGroupData, setUserGroupData] = useState({});
  const [roleOptions, setRoleOptions] = useState([]);
  const [toolRoleOptions, setToolRoleOptions] = useState([]);

  const componentRef_1 = useRef(null);
  const email = localStorage.getItem("myemail");

  const { users, loading: userLoading, fetchUsers } = useUserAdmin();
  const { roles, fetchRoles } = useRoleAdmin();
  const { fetchToolRoles } = useToolRoleAdmin();

  const personaOptions = Object.entries(userGroupMap).map(([id, name]) => ({
    value: Number(id),
    label: name,
    reportIncludedRLS: userGroupData[id]?.reportIncludedRLS || false,
  }));

  useEffect(() => {
    if (!passtoken) return;
    fetchUsers();
    fetchRoles();
  }, [passtoken, fetchUsers, fetchRoles]);

  useEffect(() => {
    if (!passtoken) return;
    fetchToolRoles()
      .then((data) => {
        setToolRoleOptions(
          (data || []).map((r) => ({ value: r.toolRoleId, label: r.roleName })),
        );
      })
      .catch(() => {});
  }, [passtoken, fetchToolRoles]);

  // Fetch the full persona/user-group list so newly created groups (with no
  // users assigned yet) still show up in the assignment dropdown & filter.
  useEffect(() => {
    if (!passtoken) return;
    apiService
      .get(apiUrl.personaUserGroups())
      .then((response) => {
        const groups = response.data?.data || [];
        const map = {};
        const dataMap = {};
        groups.forEach((g) => {
          if (g.id) {
            map[g.id] = g.name;
            dataMap[g.id] = {
              name: g.name,
              reportIncludedRLS: g.reportIncludedRLS || false,
            };
          }
        });
        setUserGroupMap((prev) => ({ ...prev, ...map }));
        setUserGroupData((prev) => ({ ...prev, ...dataMap }));
      })
      .catch(() => {});
  }, [passtoken]);

  useEffect(() => {
    if (!users || users.length === 0) return;
    setUserGroupMap((prev) => {
      const map = { ...prev };
      users.forEach((user) => {
        if (Array.isArray(user.userGroup)) {
          user.userGroup.forEach((g) => {
            if (g.userGroupId && g.userGroupName && !map[g.userGroupId]) {
              map[g.userGroupId] = g.userGroupName;
            }
          });
        }
      });
      return map;
    });
  }, [users]);

  useEffect(() => {
    if (!roles || roles.length === 0) return;
    setRoleOptions([
      { value: "", label: "None" },
      ...roles.map((r) => ({
        value: r.roleName || r.name,
        label: r.roleName || r.name,
      })),
    ]);
  }, [roles]);

  const fetchSearchByname = useCallback(() => {
    setuserinfo(users || []);
    setIsloading(userLoading);
  }, [users, userLoading]);

  useEffect(() => {
    fetchSearchByname();
  }, [users, userLoading, fetchSearchByname]);

  const sortedAsc =
    userinfo === null
      ? ""
      : userinfo
          .slice(0)
          .sort((a, b) =>
            b.lastUpdateDateTime.localeCompare(a.lastUpdateDateTime),
          );

  const search_parameters = ["emailAddress", "createdBy"];
  const filter_by_userType = [
    ...new Set(userinfo.map((item) => item.userType)),
  ];
  // Sourced from the full persona/user-group list, not just users currently loaded,
  // so newly created groups with no users yet still appear in the filter.
  const userGroupName = Object.keys(userGroupMap)
    .map(Number)
    .sort((a, b) => a - b);

  let filteredData = sortedAsc ? sortedAsc.filter((obj) => obj) : [];

  const handlePageChange = ({ selected }) => setCurrentPage(selected);

  function search() {
    return filteredData.filter(
      (item) =>
        item.userType.includes(userType) &&
        (!userGroup ||
          item.userGroup.some((g) => g.userGroupId === parseInt(userGroup))) &&
        search_parameters.some((p) =>
          item[p].toString().toLowerCase().includes(query.toLowerCase()),
        ),
    );
  }

  const printSegment = useReactToPrint({
    content: () => {
      const tableStat_1 = componentRef_1.current.cloneNode(true);
      const PrintElem = document.createElement("div");
      PrintElem.innerHTML = `<img src="${Logo}" style="padding-bottom:2rem" alt="logo" class="watermark"/>`;
      PrintElem.appendChild(tableStat_1);
      return PrintElem;
    },
  });

  const pageCount = Math.ceil(search().length / currentPagelimit);
  const currentData = search().slice(
    (currentPage - 1) * currentPagelimit,
    currentPage * currentPagelimit,
  );

  const handelepageclick = (data) => setCurrentPage(data.selected + 1);
  const resetAll = () => {
    setQuery("");
    setUserGroup("");
    setUsertype("");
    setCurrentPage(1);
  };

  const getUserDetail = (
    emailAddr,
    usersGroup,
    usersType,
    RLType,
    toolRoles,
  ) => {
    setOpen(true);
    const transformedArray = usersGroup.map((item) => ({
      value: item.userGroupId,
      label:
        item.userGroupName ||
        userGroupMap[item.userGroupId] ||
        String(item.userGroupId),
    }));
    const transformedArrayRL = RLType.map((item) => ({
      value: item.RLtypename,
      label: item.RLtypename,
    }));
    const transformedArrayToolRoles = (toolRoles || []).map((item) => ({
      value: item.toolRoleId,
      label: item.toolRoleName || String(item.toolRoleId),
    }));
    setUpdateuserType(usersType);
    setEmail(emailAddr);
    setselectedOptionsPersona(transformedArray);
    setResetselectedOptionsPersona(transformedArray);
    setResetUpdateuserType(usersType);
    setSelectedOptions(transformedArrayRL);
    setselectedOptionsToolRoles(transformedArrayToolRoles);
    setResetselectedOptionsToolRoles(transformedArrayToolRoles);
    setselectedPersona1(
      usersGroup.map((g) => ({ userGroupId: g.userGroupId })),
    );
    setselectedOptionsDataRl(RLType.map((r) => ({ RLtypename: r.RLtypename })));
    setSelectedToolRoleIds(
      (toolRoles || []).map((t) => ({ toolRoleId: t.toolRoleId })),
    );
  };

  const handleClose = (e) => {
    e.preventDefault();
    setOpen(false);
    setValidated(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!event.currentTarget.checkValidity()) return;
    setValidated(true);
    setUpdateisLoading(true);
    const data = {
      emailAddress: EmailAdress,
      userType: UpdateuserType,
      userGroup: selectedPersona1,
      rlType: selectedOptionsDataRl,
      toolRoleIds: selectedToolRoleIds,
      assignUser: email,
    };
    apiService
      .post(`${process.env.REACT_APP_SERVER_URL}/aipd/updateUser`, data)
      .then((response) => {
        if (response.status === 200) {
          fetchUsers();
          setUpdateisLoading(false);
          setValidated(false);
          setsuccess(true);
          setTimeout(() => setsuccess(false), 10000);
          seterror(false);
          setOpen(false);
        }
      })
      .catch(() => {
        setUpdateisLoading(false);
        setValidated(false);
        setsuccess(false);
        seterror(true);
        setTimeout(() => seterror(false), 10000);
      });
    setValidated(true);
  };

  const resetForm = (e) => {
    e.preventDefault();
    setValidated(false);
    setselectedOptionsPersona(ResetselectedOptionsPersona);
    setUpdateuserType(ResetUpdateuserType);
    setselectedOptionsToolRoles(ResetselectedOptionsToolRoles);
    setSelectedToolRoleIds(
      ResetselectedOptionsToolRoles.map((o) => ({ toolRoleId: o.value })),
    );
  };
  const isDeleteUser = (emailAddr) => {
    setdeleteUserEmail(emailAddr);
    setisDelete(!isDelete);
  };

  const deleteusersinfo = () => {
    setisDelete(false);
    setDeleteinguser(true);
    apiService
      .post(`${process.env.REACT_APP_SERVER_URL}/aipd/deleteUser`, {
        emailAddress: deleteUserEmail,
      })
      .then(() => {
        setDeleteissuccess(true);
        setDeleteinguser(false);
        fetchUsers();
        setTimeout(() => setDeleteissuccess(false), 5000);
      })
      .catch(() => setDeleteinguser(false));
  };

  const handleChangePersona = (opts) => {
    setselectedOptionsPersona(opts);
    setselectedPersona1(opts.map((o) => ({ userGroupId: o.value })));
  };

  const handleChange = (opts) => {
    setSelectedOptions(opts);
    setselectedOptionsDataRl(opts.map((o) => ({ RLtypename: o.value })));
  };

  const handleChangeToolRoles = (opts) => {
    setselectedOptionsToolRoles(opts);
    setSelectedToolRoleIds(opts.map((o) => ({ toolRoleId: o.value })));
  };

  // Format User Group options to display with tag styling and RLS indicator
  const formatGroupOption = (option) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <span
          style={{
            display: "inline-block",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: 600,
            // background: "#ede9fe",
            // color: "#6d28d9"
          }}
        >
          {option.label}
        </span>
        {option.reportIncludedRLS && (
          <span
            style={{
              display: "inline-block",
              padding: "2px 8px",
              borderRadius: "12px",
              fontSize: "10px",
              fontWeight: 700,
              background: "#fef3c7",
              color: "#b45309",
              marginLeft: "auto",
            }}
          >
            RLS
          </span>
        )}
      </div>
    );
  };

  return (
    <div id="Create_users_id">
      <div className="wrapper">
        {/* Toolbar + Filters */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            paddingBottom: "1rem",
          }}
        >
          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "12px", flex: "1 1 auto" }}>
            <div style={{ flex: "1 1 240px", minWidth: "220px", maxWidth: "320px" }} className="search-wrapper">
              <input
                type="search"
                autoComplete="off"
                value={query}
                className="SearchBox_new"
                placeholder="Search for Email, Assigned By"
                onChange={(e) => {
                  setQuery(e.target.value);
                  handlePageChange({ selected: 1 });
                }}
              />
            </div>
            <div className="selectParent select">
              <select
                value={userType}
                onChange={(e) => {
                  setUsertype(e.target.value);
                  handlePageChange({ selected: 1 });
                }}
                className="custom-select"
              >
                <option value="">Filter by User Type</option>
                {filter_by_userType.map((item, i) => (
                  <option key={i} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              <span className="focus"></span>
            </div>
            <div className="selectParent select">
              <select
                value={userGroup}
                onChange={(e) => {
                  setUserGroup(e.target.value);
                  handlePageChange({ selected: 1 });
                }}
                className="custom-select"
              >
                <option value="">Filter by User Group</option>
                {userGroupName.map((item, i) => (
                  <option key={i} value={item}>
                    {userGroupMap[item] || String(item)}
                  </option>
                ))}
              </select>
              <span className="focus"></span>
            </div>
            <AppButton
              variant="outline"
              title="Reset filters"
              icon={<FaRedo />}
              onClick={resetAll}
            >

              Reset
            </AppButton>

          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "10px", flexShrink: 0 }}>
            <Exportuserlist
              excelData={search()}
              fileName={`user_details_${new Date().getTime()}`}
              title="Export"
            />
            <AppButton
              onClick={printSegment}
              variant="outline"
              title="Print"
              icon={<FaPrint />}
            >
              Print
            </AppButton>
            <AppButton
              onClick={fetchUsers}
              variant="outline"
              title="Refresh"
              icon={<FaRedo />}
            >
              Refresh
            </AppButton>
          </div>
        </div>

        {/* Count + Pagination */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: "1rem",
            paddingTop: "1rem",
          }}
        >
          <div
            style={{
              fontSize: "18px",
              paddingBottom: "1rem",
              paddingTop: "1rem",
            }}
          >
            Total number of Users:{" "}
            <span style={{ fontSize: "18px", fontWeight: "600" }}>
              {search().length}
            </span>
          </div>
          <ReactPaginate
            previousLabel={"Previous"}
            nextLabel={"Next"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handelepageclick}
            containerClassName={pageCount > 1 ? "pagination" : "pagination d-none"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
            forcePage={currentPage - 1}
          />
        </div>

        {/* Table */}
        <div ref={componentRef_1}>
          <RankedTable
            columns={[
              { label: "Email" },
              { label: "Access Type", width: "220px" },
              { label: "Access Persona and Report RLS" },
              {
                label: "Actions",
                align: "center",
                renderSkeletonCell: () => (
                  <div style={{ display: "flex", justifyContent: "center", gap: "6px" }}>
                    <div className="h-6 rounded bg-gray-100 animate-pulse" style={{ width: "50px" }} />
                    <div className="h-6 rounded bg-gray-100 animate-pulse" style={{ width: "60px" }} />
                  </div>
                ),
              },
            ]}
            rows={currentData}
            loading={isLoading}
            skeletonRows={6}
            emptyText="No users available"
            renderRow={(item) => (
              <>
                <td className="px-5 py-3">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {/* <div
                      style={{
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        background: uiConfig.tableAccentGradient,
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: 700,
                        marginRight: "10px",
                        flexShrink: 0,
                      }}
                    >
                      {item.emailAddress?.[0]?.toUpperCase()}
                    </div> */}
                    <span
                      style={{
                        fontSize: "13px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "grid",
                        gap: "4px",
                      }}
                      title={item.emailAddress}
                    >
                      <span style={{ color: uiConfig.tableAccentColor }}>{item.emailAddress?.toLowerCase()}</span>
                      <span style={{ fontWeight: 400, fontSize: "10px" }}>
                        {item.createDateTime ? (
                          <>Created by: <b>{item.createdBy}</b></>
                        ) : (
                          <>Last modified by: <b>{item.createdBy}</b></>
                        )}
                      </span>
                      <span style={{ fontWeight: 400, fontSize: "10px" }}>
                        {item.lastUpdateDateTime ? (
                          <>Last modified On: <b>{item.lastUpdateDateTime}</b></>
                        ) : (
                          <>Created On: <b>{item.createDateTime}</b></>
                        )}
                      </span>
                    </span>
                  </div>
                </td>
                <td className="px-5 py-3">
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}
                  >
                    {item.toolRoles && item.toolRoles.length > 0 ? (
                      item.toolRoles.map((t) => (
                        <span
                          key={t.toolRoleId}
                          style={{
                            display: "inline-block",
                            padding: "2px 8px",
                            borderRadius: "20px",
                            fontSize: "11px",
                            fontWeight: 600,
                            background: "#ede9fe",
                            color: "#6d28d9",
                          }}
                        >
                          {t.toolRoleName}
                        </span>
                      ))
                    ) : (
                      <span style={{ color: "#9ca3af", fontSize: "12px" }}>
                        —
                      </span>
                    )}
                  </div>
                </td>
                <td className="px-5 py-3">
                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "4px" }}>
                      {item.userGroup?.map((g, gi) => {
                        const label =
                          g.userGroupName ||
                          userGroupMap[g.userGroupId] ||
                          String(g.userGroupId);
                        return (
                          <span
                            key={gi}
                            style={{
                              display: "inline-block",
                              padding: "2px 8px",
                              borderRadius: "20px",
                              fontSize: "11px",
                              fontWeight: 600,
                              background: "#dbeafe",
                              color: "#1d4ed8",
                            }}
                          >
                            {label}
                          </span>
                        );
                      })}
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "4px" }}>
                    
                      {item.rlType && item.rlType.length > 0 ? (
                        item.rlType.map((r) => (
                          <span
                            key={r.RLtypename}
                            style={{
                              display: "inline-block",
                              padding: "2px 8px",
                              borderRadius: "20px",
                              fontSize: "10px",
                              fontWeight: 600,
                              background: "#fbe9fd",
                              color: "#bb1ccc",
                            }}
                          >
                            {r.RLtypename}
                          </span>
                        ))
                      ) : (
                        <span>
                          
                        </span>
                      )}
                    </div>
                  </div>
                </td>
                <td className="px-5 py-3 text-center">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "6px",
                    }}
                  >
                    <AppButton
                      variant="fill"
                      onClick={() =>
                        getUserDetail(
                          item.emailAddress,
                          item.userGroup,
                          item.userType,
                          item.rlType,
                          item.toolRoles,
                        )
                      }
                      style={{ padding: "4px 12px", fontSize: "11px" }}
                    >
                      Edit Users
                    </AppButton>
                    <AppButton
                      variant="outline"
                      onClick={() => isDeleteUser(item.emailAddress)}
                      style={{ padding: "4px 12px", fontSize: "11px" }}
                    >
                      Delete Users
                    </AppButton>
                  </div>
                </td>
              </>
            )}
          />
        </div>
      </div>

      {/* Alerts */}
      {issuccess && (
        <Alert
          style={{ position: "absolute", right: "20px", top: "14px" }}
          variant="success"
        >
          <p className="mb-0">User Details Successfully Updated</p>
        </Alert>
      )}
      {iserror && (
        <Alert
          style={{ position: "absolute", right: "20px", top: "14px" }}
          variant="danger"
        >
          <p className="mb-0">
            Something went wrong!! Please try after sometime
          </p>
        </Alert>
      )}
      {Deleteissuccess && (
        <Alert
          style={{ position: "absolute", right: "20px", top: "14px" }}
          variant="success"
        >
          <p className="mb-0">
            {deleteUserEmail} User Details Deleted Successfully
          </p>
        </Alert>
      )}

      {/* Edit Dialog */}
      {open && (
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{ sx: { minWidth: "500px" } }}
        >
          {UpdateisLoading ? (
            <>
              <DialogTitle
                style={{
                  background: uiConfig.dialogHeaderGradient,
                  color: "#fff",
                  fontWeight: "500",
                }}
              >
                Updating Details
              </DialogTitle>
              <DialogContent
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "60px 40px",
                  minHeight: "300px",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    border: "4px solid #e5e7eb",
                    borderTop: `4px solid ${uiConfig.dialogHeaderGradient}`,
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                    marginBottom: "20px",
                  }}
                />
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#374151",
                    margin: "0",
                    textAlign: "center",
                  }}
                >
                  Updating Details...
                </p>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#9ca3af",
                    margin: "8px 0 0 0",
                    textAlign: "center",
                  }}
                >
                  Please wait while we update your information
                </p>
                <style>{`
                  @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                  }
                `}</style>
              </DialogContent>
            </>
          ) : (
            <>
              <DialogTitle
                style={{
                  background: uiConfig.dialogHeaderGradient,
                  color: "#fff",
                  fontWeight: "500",
                }}
              >
                Update Details
              </DialogTitle>
              <DialogContent style={{ marginTop: "16px" }}>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="validationCustom01">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        value={EmailAdress}
                        disabled
                        style={{ cursor: "no-drop" }}
                      />
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group
                      as={Col}
                      controlId="validationCustom02ToolRoles"
                    >
                      <Form.Label>
                        Access Type <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Select
                        isMulti
                        options={toolRoleOptions}
                        value={selectedOptionsToolRoles}
                        onChange={handleChangeToolRoles}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                        menuPosition={"fixed"}
                      />
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="validationCustom03">
                      <Form.Label>
                        Persona Type <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Select
                        isMulti
                        options={personaOptions}
                        required
                        value={selectedOptionsPersona}
                        onChange={handleChangePersona}
                        formatOptionLabel={formatGroupOption}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                        menuPosition={"fixed"}
                      />
                    </Form.Group>
                  </Row>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="validationCustom04">
                      <Form.Label>
                        Report RLS <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Select
                        options={roleOptions}
                        required
                        isMulti
                        value={selectedOptions}
                        onChange={handleChange}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                        menuPosition={"fixed"}
                      />
                    </Form.Group>
                  </Row>
                  <div
                    style={{
                      gridGap: "10px",
                      display: "flex",
                      marginTop: "2rem",
                      justifyContent: "flex-end",
                    }}
                    className="mb-3"
                  >
                    <AppButton onClick={handleClose} variant="secondary">
                      Close
                    </AppButton>
                    <AppButton
                      onClick={resetForm}
                      variant="secondary"
                      type="reset"
                    >
                      Reset
                    </AppButton>
                    <AppButton type="submit" variant="primary">
                      Update
                    </AppButton>
                  </div>
                </Form>
              </DialogContent>
            </>
          )}
        </Dialog>
      )}

      {/* Delete Dialog */}
      {isDelete && (
        <Dialog open={isDelete} onClose={() => setisDelete(false)}>
          <DialogTitle>
            Are you sure you want to delete this user {deleteUserEmail}?
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              If you are certain about deleting this User, click "OK."
              Otherwise, click "Cancel."
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <AppButton variant="secondary" onClick={() => setisDelete(false)}>
              Cancel
            </AppButton>
            <AppButton variant="primary" onClick={deleteusersinfo} autoFocus>
              Ok
            </AppButton>
          </DialogActions>
        </Dialog>
      )}

      {/* Deleting overlay */}
      {Deleteinguser && (
        <div
          style={{
            position: "fixed",
            background: "rgba(0,0,0,0.8)",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            zIndex: 99999,
            justifyItems: "center",
            alignContent: "center",
          }}
        >
          <img width={200} src={preloadimg} alt="Loading" />
          <span>Deleting User Please wait...</span>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
